import { useAbilityOverrides } from '@cast/infrastructure-abilities';

export const addAbilityOverrides = () => {
  window.abilityOverrides = useAbilityOverrides.getState;
};
